import { contactsTypes } from "../constantes/actionTypes"

const initialState = []

export const contacts = (state = initialState, action) => {
    switch (action.type) {
        case contactsTypes.GET_ALL_CONTACTS_SUCCESS:
            return action.payload
        case contactsTypes.GET_ALL_CONTACTS_FAILURE:
            return initialState
        case contactsTypes.UPDATE_CONTACT_SUCCESS:
            const updateContact = state.map(item => {
                if(item.id_Contacto == action.payload.id_Contacto){
                    return action.payload
                }
                return item
            })
            return updateContact
        case contactsTypes.NEW_CONTACT_SUCCESS:
            return [...state, action.payload]
        case contactsTypes.DELETE_CONTACT_SUCCESS:
            return state.filter(x => x.id_Contacto !== action.payload)
        case contactsTypes.NEW_CONTACT_FAILURE:
        case contactsTypes.UPDATE_CONTACT_FAILURE:
            return state
        default:
            return state
    }
}